module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-2-photo-5-5e19a9c6f3836e8dc55e15a0c4dc5637.webp";